/*
 * File: FeedComponent.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 18, 2025 at 1:59 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 29, 2025 at 12:30 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div``;

export const FeedActionBar = styled.div`
	position: relative;
	padding: 0px 0px 6px;
	display: flex;
	gap: 0px;
	margin: 0px 0px 0px -10px;
`;

export const Spacer = styled.div`
	flex-grow: 1;
`;

export const TagSelectorWidget = styled.div`
	height: ${({ $isOpen, $height }) => ($isOpen ? $height + 20 : 0)}px;
	opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
	padding: 0px 1px;
	position: relative;
`;

export const TagFamilyContainer = styled.div`
	display: flex;
	flex-direction: column;
	gap: 15px;
	margin: 3px 0px 0px;
	position: absolute;
	top: 0px;
	left: 0px;
`;

export const TagFamily = styled.div`
	& > p {
		margin: 0px 0px 8px;
		color: ${({ theme }) => theme.secondaryText};
	}
`;

export const TagContainer = styled.div`
	display: flex;
	gap: 6px;
	flex-wrap: wrap;

	p {
		text-align: left;
	}
`;

export const ActiveTagCount = styled.div`
	background-color: ${({ theme }) => theme.primaryDecoration};
	padding: 0px 7px;
	border-radius: 10px;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 20px;
	min-width: 20px;

	* {
		color: ${({ theme }) => theme.primaryBackground};
	}
`;
